import React, { cloneElement } from 'react';

import { useCallbackWithAnalytics } from '@atlaskit/analytics-next';

const noop = () => {};
export function WebItemAnalyticsWrapper({
	children,
	analyticsData,
	innerRef,
	wrapChildren = false,
}: {
	children: React.ReactElement;
	analyticsData?: object;
	innerRef?: React.Ref<any>;
	wrapChildren?: boolean;
}) {
	const handler = children?.props?.onClick || noop;
	const handleClick = useCallbackWithAnalytics(handler, analyticsData!);
	if (wrapChildren) {
		return (
			// eslint-disable-next-line @atlassian/a11y/no-static-element-interactions
			<span ref={innerRef} onMouseDown={handleClick}>
				{children}
			</span>
		);
	}
	return cloneElement(children, {
		onClick: handleClick,
		ref: innerRef,
	});
}
